import { _ as t } from "./_baseToString.mjs";
var n = t;
function o(r) {
  return r == null ? "" : n(r);
}
var a = o;
export {
  a as t
};
//# sourceMappingURL=toString.mjs.map
